<template>
    <div class="modern-form-container">

      <!-- Progress Steps -->
      <div class="form-progress mb-4">
        <div class="step-container" :class="`step-${currentStep}`">
          <div class="step col-md-3" :class="{ active: currentStep >= 1, completed: currentStep > 1 }">
            <div class="step-number">1</div>
            <span>Informations</span>
          </div>
          <div class="step col-md-3" :class="{ active: currentStep >= 2, completed: currentStep > 2 }">
            <div class="step-number">2</div>
            <span>Classification</span>
          </div>
          <div class="step col-md-3" :class="{ active: currentStep >= 3, completed: currentStep > 3 }">
            <div class="step-number">3</div>
            <span>Fichier</span>
          </div>
          <div class="step col-md-3" :class="{ active: currentStep >= 4 }">
            <div class="step-number">4</div>
            <span>Confirmation</span>
          </div>
        </div>
      </div>

      <div class="card modern-card">
        <div class="card-body p-4">
          <Form ref="documentForm" 
          @submit="addDocument" 
          :validation-schema="documentSchema"
          :initial-values="formData"
          v-slot="{ setFieldValue }"
          >
            
            <!-- Step 1: Basic Information -->
            <div :class="{ 'd-none': currentStep !== 1 }" class="step-content">
              <h4 class="step-title mb-4">
                <i class="fas fa-info-circle me-2"></i>
                Informations du Document
              </h4>
                <div class="row">

                  <div class="col-md-3">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="text-black fw-semibold mb-10">
                        <Field name="estTelechargeable" type="checkbox" 
                          
                          :value="true"
                          :unchecked-value="false"
                        class="form-check-input shadow-none" />
                      Est Téléchargeable ?  
                    </label>
                      <ErrorMessage name="estTelechargeable" class="text-danger"/>
                  </div>
                  </div>

                  <div class="col-md-3">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="text-black fw-semibold mb-10">
                        <Field name="estPublique" type="checkbox" 
                          
                          :value="true"
                          :unchecked-value="false"
                        class="form-check-input shadow-none" />
                      Est Publique ?  
                    </label>
                      <ErrorMessage name="estPublique" class="text-danger"/>
                  </div>
                  </div>

                  <div style="clear: both;"></div>

                  <div class="col-md-4">
                    <div class="modern-input-group">
                      <label for="titre" class="modern-label">
                        <i class="fas fa-book me-2"></i>
                        Réference<span class="text-danger">*</span>
                      </label>
                      <Field 
                        name="reference" 
                        type="text" 
                        class="form-control shadow-none fs-md-15 text-black modern-input" 
                        placeholder="Référence du document"
                        @update:modelValue="(value) => { setFieldValue('reference', value); 
                        updateFormField('reference', value); }" />
                      <ErrorMessage name="reference" class="text-danger"/>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="modern-input-group">
                      <label for="titre" class="modern-label">
                        <i class="fas fa-book me-2"></i>
                        Titre<span class="text-danger">*</span>
                      </label>
                      <Field 
                        name="titre" 
                        type="text" 
                        class="form-control shadow-none fs-md-15 text-black modern-input" 
                        placeholder="Entrer le titre du document"
                        @update:modelValue="(value) => { setFieldValue('titre', value); 
                        updateFormField('titre', value); }" />
                      <ErrorMessage name="titre" class="text-danger"/>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="modern-input-group">
                      <label for="sousTitre" class="modern-label">
                        <i class="fas fa-book me-2"></i>
                        Sous Titre
                      </label>
                      <Field 
                        name="sousTitre" 
                        type="text" 
                        class="form-control shadow-none fs-md-15 text-black modern-input" 
                        placeholder="Entrer le sous titre du document"
                        @update:modelValue="(value) => { setFieldValue('sousTitre', value); updateFormField('sousTitre', value); }" />
                      <ErrorMessage name="sousTitre" class="text-danger"/>
                    </div>
                  </div>

                  <!-- <div class="col-md-4">
                    <div class="modern-input-group">
                      <label for="sujet" class="modern-label">
                        <i class="fas fa-book me-2"></i>
                        Sujet
                      </label>
                      <Field 
                        name="sujet" 
                        type="text" 
                        class="form-control shadow-none fs-md-15 text-black modern-input" 
                        placeholder="Entrer le sujet du document"
                        @update:modelValue="(value) => { setFieldValue('sujet', value); updateFormField('sujet', value); }" />
                      <ErrorMessage name="sujet" class="text-danger"/>
                    </div>
                  </div> -->

                  <div class="col-md-3">
                    <div class="modern-input-group">
                      <label for="anneePublication" class="modern-label">
                        <i class="fas fa-calendar me-2"></i>
                        Année de Publication<span class="text-danger">*</span>
                      </label>
                      <Field 
                        name="anneePublication" 
                        type="number" 
                        class="form-control shadow-none fs-md-15 text-black modern-input" 
                        placeholder="2025"
                        @update:modelValue="(value) => { setFieldValue('anneePublication', value); updateFormField('anneePublication', value); }" />
                      <ErrorMessage name="anneePublication" class="text-danger"/>
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="modern-input-group">
                      <label for="version" class="modern-label">
                        <i class="fas fa-book me-2"></i>
                        Version<span class="text-danger">*</span>
                      </label>
                      <Field 
                        name="version" 
                        type="number" 
                        :value="1"
                        class="form-control shadow-none fs-md-15 text-black modern-input" 
                        placeholder="Entrer la version du document"
                        @update:modelValue="(value) => { setFieldValue('version', value); updateFormField('version', value); }" />
                      <ErrorMessage name="version" class="text-danger"/>
                    </div>
                  </div>
                

                  <div class="col-md-6">
                    <div class="modern-select-group">
                      <label class="modern-label">
                        <i class="fas fa-folder me-2"></i>
                        Langue <span class="text-danger">*</span>
                      </label>
                      <Field name="langue" type="text" v-slot="{ field }">
                        <Multiselect 
                          v-model="field.value" 
                          v-bind="field" 
                          :options="langueOptions" 
                          :preserve-search="true"
                          :multiple="false" 
                          :searchable="true" 
                          placeholder="Sélectionner la langue"
                          label="label" 
                          track-by="label"
                          @change="(value) => { setFieldValue('langue', value); updateFormField('langue', value); }"
                          class="modern-multiselect" />
                      </Field>
                       <ErrorMessage name="langue" class="text-danger"/>
                      <!-- <span class="error-message" v-if="showMErr">La langue est obligatoire </span> -->
                    </div>
                  </div>

                  <!-- <div class="col-md-12">
                    <div class="modern-input-group">
                      <label for="sousTitre" class="modern-label">
                        <i class="fas fa-book me-2"></i>
                       Description<span class="text-danger">*</span>
                      </label>
                      <Field name="description" type="text" @input="updateDescription"
                      class="form-control shadow-none fs-md-15 text-black modern-input" placeholder="Entrer la description du document"/>
                      <ErrorMessage name="description" class="text-danger"/>
                    </div>
                  </div> -->

                  <div class="col-md-12 mb-12">
                    <div class="modern-input-group">
                      <label class="modern-label">
                        Résumé / Description
                      </label>
                      <Field name="description" v-slot="{ field }">
                        <textarea 
                          v-model="field.value"
                          class="form-control shadow-none rounded-0 text-black modern-input"
                          cols="20" 
                          rows="4"
                          placeholder="Entrer la description du document"
                         >
                        </textarea>
                      </Field>
                      <ErrorMessage name="description" class="text-danger" />
                    </div>
                  </div>

                </div>
              </div>

            <!-- Step 2: Classification -->
            <div :class="{ 'd-none': currentStep !== 2 }" class="step-content">
                <h4 class="step-title mb-4">
                  <i class="fas fa-tags me-2"></i>
                  Classification du Document
                </h4>
                <div class="row">

                  <div class="col-md-4">
                    <div class="modern-select-group">
                      <label class="modern-label">
                        <i class="fas fa-folder me-2"></i>
                        Direction <span class="text-danger">*</span>
                      </label>
                      <Field name="direction" v-slot="{ field }">
                        <Multiselect 
                          :appendToBody="true" 
                          v-model="field.value" 
                          :options="directionOptions" 
                          :preserve-search="true"
                          :multiple="false" 
                          :searchable="true" 
                          placeholder="Sélectionner la direction"
                          label="label" 
                          track-by="label"
                          class="modern-multiselect"
                          @change="(value) => { setFieldValue('direction', value); updateFormField('direction', value); }" />
                      </Field>
                      <ErrorMessage name="direction" class="text-danger"/>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="modern-select-group">
                      <label class="modern-label">
                        <i class="fas fa-folder me-2"></i>
                        Service <span class="text-danger">*</span>
                      </label>
                      <Field name="service" v-slot="{ field }">
                        <Multiselect 
                          :appendToBody="true" 
                          v-model="field.value" 
                          :options="filteredServiceOptions" 
                          :preserve-search="true"
                          :multiple="false" 
                          :searchable="true" 
                          placeholder="Sélectionner le service"
                          label="label" 
                          track-by="label"
                          class="modern-multiselect"
                          @change="(value) => { setFieldValue('service', value); updateFormField('service', value); }" />
                      </Field>
                      <ErrorMessage name="service" class="text-danger"/>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="modern-select-group">
                      <label class="modern-label">
                        <div class="d-flex justify-content-between align-items-center">
                          <span>Auteur <span class="text-danger">*</span></span>
                          <span 
                            class=" btn btn-primary py-1 px-2 fs-12" 
                            style="cursor: pointer;"
                            data-bs-toggle="modal"
                            data-bs-target="#AddElementModal"
                            title="Ajouter un nouvel auteur">
                            Nouveau
                          </span>
                        </div>

                      </label>
                      <Field name="auteur" v-model="auteurSelected" v-slot="{ field }">
                        <Multiselect 
                          :appendToBody="true" 
                          v-model="field.value" 
                          :options="auteurOptions" 
                          :preserve-search="true"
                          :multiple="false" 
                          :searchable="true" 
                          placeholder="Sélectionner l'auteur"
                          label="label" 
                          track-by="label"
                          class="modern-multiselect"
                          @change="(value) => { setFieldValue('auteur', value); updateFormField('auteur', value); }"/>
                       </Field>
                      <ErrorMessage name="auteur" class="text-danger"/>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="modern-select-group">
                      <label class="modern-label">
                        <i class="fas fa-folder me-2"></i>
                        Type de fichier <span class="text-danger">*</span>
                      </label>
                      <Field name="typeFichier" v-slot="{ field }">
                        <Multiselect 
                          :appendToBody="true" 
                          v-model="field.value" 
                          :options="typeFichierOptions" 
                          :preserve-search="true"
                          :multiple="false" 
                          :searchable="true" 
                          placeholder="Sélectionner le type de fichier"
                          label="label" 
                          track-by="label"
                          class="modern-multiselect"
                          @change="(value) => { setFieldValue('typeFichier', value); updateFormField('typeFichier', value); }" />
                      </Field>
                      <ErrorMessage name="typeFichier" class="text-danger"/>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="modern-select-group">
                      <label class="modern-label">
                        <i class="fas fa-folder me-2"></i>
                        Catégorie <span class="text-danger">*</span>
                      </label>
                      <Field name="categorie" v-slot="{ field }">
                        <Multiselect 
                          :appendToBody="true" 
                          v-model="field.value" 
                          :options="categorieOptions" 
                          :preserve-search="true"
                          :multiple="false" 
                          :searchable="true" 
                          placeholder="Sélectionner la catégorie"
                          label="label" 
                          track-by="label"
                          class="modern-multiselect"
                          @change="(value) => { setFieldValue('categorie', value); updateFormField('categorie', value); }" />
                      </Field>
                      <ErrorMessage name="categorie" class="text-danger"/>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="modern-select-group">
                      <label class="modern-label">
                        <div class="d-flex justify-content-between align-items-center">
                          <span>Maison d'Edition <span class="text-danger">*</span></span>
                          <span 
                            class=" btn btn-primary py-1 px-2 fs-12" 
                            style="cursor: pointer;" 
                            title="Ajouter une nouvelle maison d'édition">
                            Nouveau
                          </span>
                        </div>
                      </label>
                      <Field name="maisonEdition" v-slot="{ field }">
                        <Multiselect 
                          :appendToBody="true" 
                          v-model="field.value" 
                          :options="maisonEditionOptions" 
                          :preserve-search="true"
                          :multiple="false" 
                          :searchable="true" 
                          placeholder="Sélectionner la maison d'Edition"
                          label="label" 
                          track-by="label"
                          class="modern-multiselect"
                          @change="(value) => { setFieldValue('maisonEdition', value); updateFormField('maisonEdition', value); }" />
                      </Field>
                      <ErrorMessage name="maisonEdition" class="text-danger" />
                    </div>
                  </div>

                    <div class="col-md-4">
                    <div class="modern-select-group">
                      <label class="modern-label">
                        <i class="fas fa-folder me-2"></i>
                        Secteur <span class="text-danger">*</span>
                      </label>
                      <Field name="secteur" v-slot="{ field }">
                        <Multiselect 
                          :appendToBody="true" 
                          v-model="field.value" 
                          :options="secteurOptions" 
                          :preserve-search="true"
                          :multiple="false" 
                          :searchable="true" 
                          placeholder="Sélectionner le secteur"
                          label="label" 
                          track-by="label"
                          class="modern-multiselect"
                          @change="(value) => { setFieldValue('secteur', value); updateFormField('secteur', value); }" />
                      </Field>
                      <ErrorMessage name="secteur" class="text-danger"/>
                    </div>
                  </div>



                  <div class="col-md-4">
                    <div class="modern-select-group">
                      <label class="modern-label">
                        <div>
                          <span>Genre <span class="text-danger">*</span></span>
                        </div>
                      </label>
                      <Field name="genre" v-slot="{ field }">
                        <Multiselect 
                          :appendToBody="true" 
                          v-model="field.value" 
                          :options="genreOptions" 
                          :preserve-search="true"
                          mode="tags"
                          :multiple="false" 
                          :searchable="true" 
                          placeholder="Sélectionner le genre"
                          label="label" 
                          track-by="label"
                          class="modern-multiselect"
                          @change="(value) => { setFieldValue('genre', value); updateFormField('genre', value); }" />
                      </Field>
                      <ErrorMessage name="genre" class="text-danger" />
                    </div>
                  </div>


                   <div class="col-md-4">
                    <div class="modern-select-group">
                      <label class="modern-label">
                        <div class="d-flex justify-content-between align-items-center">
                          <span>Mot clé associé <span class="text-danger">*</span></span>
                          <span 
                            class=" btn btn-primary py-1 px-2 fs-12" 
                            style="cursor: pointer;" 
                            title="Ajouter un nouveau mot clé">
                            Nouveau
                          </span>
                        </div>
                      </label>
                      <Field name="tag" v-slot="{ field }">
                        <Multiselect 
                          :appendToBody="true" 
                          v-model="field.value" 
                          :options="tagOptions" 
                          :preserve-search="true"
                          :multiple="false" 
                          mode="tags"
                          :searchable="true" 
                          placeholder="Sélectionner un mot clé"
                          label="label" 
                          track-by="label"
                          class="modern-multiselect"
                          @change="(value) => { setFieldValue('tag', value); updateFormField('tag', value); }" />
                      </Field>
                      <ErrorMessage name="tag" class="text-danger" />
                    </div>
                  </div>


                </div>
                
              </div>

            <!-- Step 3: File Upload -->
            <div :class="{ 'd-none': currentStep !== 3 }" class="step-content">
              <h4 class="step-title mb-4">
                  <i class="fas fa-cloud-upload-alt me-2"></i>
                  Chargement du Document
                </h4>
                 <div class="file-upload-zone" 
                     @drop.prevent="handleFileDrop" 
                     @dragover.prevent="dragOver = true"
                     @dragleave.prevent="dragOver = false"
                     :class="{ 'drag-over': dragOver }">
                  <div class="upload-content" v-if="!selectedFile">
                    <i class="fas fa-cloud-upload-alt upload-icon"></i>
                    <h5>Glissez-déposez votre fichier ici</h5>
                    <p class="text-muted">ou</p>
                    <button type="button" class="btn btn-outline-primary" @click="fileInput?.click()">
                      <i class="fas fa-folder-open me-2"></i>
                      Parcourir les fichiers
                    </button>

                    <input 
                      ref="fileInput" 
                      type="file" 
                      name="nomFichier"
                      @change="handleFileSelect" 
                      accept=".pdf,.doc,.docx,.txt,.jpg,.jpeg,.png,.gif,.webp,.bmp,.mp4,.mov,.avi,.mkv,.webm,.flv,.wmv"
                      style="display: none;" />
                    
                    <!-- Afficher le message d'erreur pour le fichier -->
                    <ErrorMessage name="nomFichier" class="text-danger mt-2" />

                    <small class="text-muted d-block mt-2">
                      Formats acceptés: PDF, DOC, DOCX, TXT, JPG, PNG, GIF, WEBP, MP4, MOV, AVI, MKV, WEBM (Max: 10MB)
                    </small>
                  </div>
                  
                  <!-- File Preview -->
                  <div class="file-preview" v-if="selectedFile">
                    <div class="file-info">
                      <i class="fas fa-file-alt file-icon" v-if="!isImageFile(selectedFile) && !isVideoFile(selectedFile)"></i>
                      <i class="fas fa-image file-icon text-success" v-if="isImageFile(selectedFile)"></i>
                      <i class="fas fa-video file-icon text-primary" v-if="isVideoFile(selectedFile)"></i>
                      <div class="file-details">
                        <h6>{{ selectedFile.name }}</h6>
                        <small class="text-muted">{{ formatFileSize(selectedFile.size) }}</small>
                        <small class="badge bg-primary ms-2 text-white" v-if="isImageFile(selectedFile)">Image</small>
                        <small class="badge bg-primary ms-2 text-white" v-if="isVideoFile(selectedFile)">Vidéo</small>
                        <small class="badge bg-primary ms-2 text-white" v-if="!isImageFile(selectedFile) && !isVideoFile(selectedFile)">Document</small>
                      </div>
                      <button type="button" class="btn btn-sm btn-outline-danger" @click="removeFile">
                        <!-- <i class="fas fa-minus"></i> -->
                        <i class="flaticon-minus p-1"></i>
                      </button>
                    </div>
                    
                    <!-- Aperçu de l'image si c'est une image -->
                    <div class="image-preview mt-3" v-if="isImageFile(selectedFile) && imagePreviewUrl">
                      <img :src="imagePreviewUrl" alt="Aperçu" class="preview-image" />
                    </div>

                    <!-- Aperçu de la vidéo si c'est une vidéo -->
                    <div class="video-preview mt-3" v-if="isVideoFile(selectedFile) && videoPreviewUrl">
                      <video :src="videoPreviewUrl" controls class="preview-video" preload="metadata">
                        Votre navigateur ne supporte pas la lecture vidéo.
                      </video>
                    </div>
                    
                    <div class="upload-progress" v-if="uploadProgress > 0">
                      <div class="progress">
                        <div class="progress-bar" :style="{ width: uploadProgress + '%' }"></div>
                      </div>
                      <small>{{ uploadProgress }}% uploadé</small>
                    </div>
                  </div>
                 </div>
              </div>

            <!-- Step 4: Confirmation -->
            <div :class="{ 'd-none': currentStep !== 4 }" class="step-content">
              <h4 class="step-title mb-4">
                <i class="fas fa-check-circle me-2"></i>
                Confirmation
              </h4>
                <div class="confirmation-card">
                  <div class="summary-section">

                    <h6><i class="fas fa-book me-2"></i>INFORMATION DU DOCUMENT</h6>

                    <table class="table mb-4">
                      <tbody>
                        <tr>
                          <td class="w-25 p-2"><strong>Réference :</strong></td>
                          <td class="p-2">{{ (formData.reference) ? formData.reference : 'N/A' }}</td>
                        </tr>
                        <tr>
                          <td class="w-25 p-2"><strong>Titre :</strong></td>
                          <td class="p-2">{{ (formData.titre) ? formData.titre : 'N/A' }}</td>
                        </tr>
                        <tr>
                          <td class="w-25 p-2"><strong>Sous Titre :</strong></td>
                          <td class="p-2">{{ (formData.sousTitre) ? formData.sousTitre : 'N/A' }}</td>
                        </tr>
                        <tr>
                          <td class="w-25 p-2"><strong>Version :</strong></td>
                          <td class="p-2">{{ (formData.version) ? formData.version : 'N/A' }}</td>
                        </tr>
                        <tr>
                          <td class="w-25 p-2"><strong>Année :</strong></td>
                          <td class="p-2">{{ (formData.anneePublication) ? formData.anneePublication : 'N/A' }}</td>
                        </tr>
                        <tr>
                          <td class="w-25 p-2"><strong>Auteur :</strong></td>
                          <td class="p-2"></td>
                        </tr>
                      </tbody>
                    </table>

                    <h6><i class="fas fa-book me-2"></i>CLASSIFICATION</h6>

                    <table class="table mb-4">
                      <tbody>
                        <tr>
                          <td class="w-25 p-2"><strong>Direction :</strong></td>
                          <td class="p-2"> {{ (formData.direction) ? formData.direction : 'N/A' }}</td>
                        </tr>
                        <tr>
                          <td class="w-25 p-2"><strong>Service :</strong></td>
                          <td class="p-2"> {{ (formData.service) ? formData.service : 'N/A' }}</td>
                        </tr>
                        <tr>
                          <td class="w-25 p-2"><strong>Type de Fichier :</strong></td>
                          <td class="p-2"> {{ (formData.typeFichier) ? formData.typeFichier : 'N/A' }}</td>
                        </tr>
                        <tr>
                          <td class="w-25 p-2"><strong>Catégorie :</strong></td>
                          <td class="p-2"> {{ (formData.categorie) ? formData.categorie : 'N/A' }}</td>
                        </tr>
                        <tr>
                          <td class="w-25 p-2"><strong>Maison d'Edition :</strong></td>
                          <td class="p-2"> {{ (formData.maisonEdition) ? formData.maisonEdition : 'N/A' }}</td>
                        </tr>
                      </tbody>
                    </table>

                    <h6><i class="fas fa-book me-2"></i>FICHIER</h6>

                    <table class="table mb-4">
                      <tbody>
                        <tr>
                          <td class="w-25 p-2"><strong>Nom :</strong></td>
                          <td class="p-2"> {{ (selectedFile) ? selectedFile.name : '-' }} </td>
                        </tr>
                      </tbody>
                    </table>

                    <!-- <p><strong class="mb-3 w-100">Réference:</strong> {{ (formData.reference) ? formData.reference : 'N/A' }}</p>
                    <p><strong>Titre:</strong> {{ (formData.titre) ? formData.titre : 'N/A' }}</p>
                    <p><strong>Sous Titre:</strong> {{ (formData.sousTitre) ? formData.sousTitre : 'N/A' }}</p>
                    <p><strong>Version:</strong> {{ (formData.version) ? formData.version : 'N/A' }}</p>
                    <p><strong>Année:</strong> {{ (formData.anneePublication) ? formData.anneePublication : 'N/A' }}</p> -->
                    <!-- <p><strong>Langue:</strong> {{ getLangueLabel(formData.langue) }}</p>
                    <br>
                    <p><strong>Catégorie:</strong> {{ getCategoryLabel(formData.categorie) }}</p>
                    <p><strong>Maison d'Edition:</strong> {{ getMaisonEditionLabel(formData.maisonEdition) }}</p>
                    <p><strong>Description:</strong> {{ (formData.description) ? formData.description : 'N/A' }}</p> -->
                    <!-- <p v-if="selectedFile"><strong>Fichier:</strong> {{ selectedFile.name }}</p> -->
                  </div>
                </div>
              </div>

            <!-- Navigation Buttons -->
            <div class="form-navigation mt-4">
              <!-- Field caché pour VeeValidate - géré par le fichier -->
              <Field 
                name="nomFichier"
                type="text"
                v-model="formData.nomFichier"
                style="position: absolute; left: -9999px; opacity: 0; pointer-events: none;" />
              
              <button 
                type="button" 
                class="btn btn-outline-secondary me-3" 
                @click="previousStep" 
                v-if="currentStep > 1">
                <i class="fas fa-arrow-left me-2"></i>
                Précédent
              </button>

              <!-- <button
                class=" default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16"
                type="submit"
                @click="nextStep" 
                v-if="currentStep < 4"
                :disabled="!canProceedToNextStep">
                Suivant
              </button> -->
              
              <button
                type="button" 
                v-show="canProceedToNextStep"
                class="default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16"
                @click="nextStep"
                v-if="currentStep < 4"
                :disabled="!canProceedToNextStep">
                Suivant
                <i class="fas fa-arrow-right ms-2"></i>
              </button>
              
              <button 
                class="btn btn-success me-3" 
                type="submit" 
                v-if="currentStep === 4" 
                :disabled="isSubmitting"> 
                <i class="fas fa-plus me-2" v-if="!isSubmitting"></i>
                <i class="fas fa-spinner fa-spin me-2" v-if="isSubmitting"></i>
                {{ isSubmitting ? 'Enregistrement en cours...' : 'Enregistrer le document' }}
              </button>
              
              <router-link to="/documents/liste-document" 
              class="btn btn-danger border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35  fs-md-15 fs-lg-16"
              >
                <i class="fas fa-times me-2"></i>
                Annuler
              </router-link>
            </div>

          </Form>
        </div>
      </div>
    </div>
    <br> <br>

    <AddAuteurModal  @close="handleClose"  />

  </template>
  
  <script lang="ts">
  
  import { defineComponent, onMounted, ref, computed, reactive, watch} from 'vue';
  import { Form, Field, ErrorMessage } from 'vee-validate';
  import * as Yup from 'yup';
  import axios from 'axios';
  import ApiService from '@/services/ApiService';
  import { Document } from '@/models/Document';
  import { error, success } from '@/utils/utils';
  import { useRouter } from 'vue-router';
  import Multiselect from '@vueform/multiselect/src/Multiselect';
  import AddAuteurModal from './AddAuteur.vue';
  
  
  export default defineComponent({
      name: "AddDocument",
      components: {
      Form,
      Field,
      AddAuteurModal,
      ErrorMessage,
      Multiselect
    },
  
    setup: () => {
      const documentSchema = Yup.object().shape({
        titre: Yup.string().required("Le titre est obligatoire."),
        sousTitre: Yup.string().optional(), 
        version: Yup.string().optional(),   
        description: Yup.string().optional(), 
        anneePublication: Yup.string().required("L'année de publication est obligatoire."),   
        categorie: Yup.number().required("La catégorie est obligatoire."),
        secteur: Yup.number().required("Le secteur est obligatoire."),
        langue: Yup.number().required("La langue est obligatoire."),
        maisonEdition: Yup.number().required("La maison d'édition est obligatoire."),
        nomFichier: Yup.string().required("Le fichier est obligatoire."),
        genre: Yup.number().optional(),
        tag: Yup.array().optional(),
      });
  
      

      // Computed pour le nom du fichier
      const selectedFileName = computed(() => {
        return selectedFile.value ? selectedFile.value.name : '';
      });
  
      
      // const documentForm = ref<Document | null>(null);
      const documentForm = ref<InstanceType<typeof Form> | null>(null);
      const showMErr = ref(false);
      const categories = ref();
      const secteurs = ref();
      const maisonEditionOptions = ref();
      const categorieOptions = ref([]);
      const langueOptions = ref([]);
      const directionOptions = ref([]);
      const serviceOptions = ref([]);
      const secteurOptions = ref([]);
      const auteurOptions = ref<{ value: any; label: any }[]>([]);
      const tagOptions = ref([]);
      const genreOptions = ref([]);
      const auteurSelected = ref();
      const filteredServiceOptions = ref([])
      
      // const defaultEstTelechargeable = ref(false);
      // const defaultEstPublique = ref(false);
      const router = useRouter();
      const typeFichierOptions = ref([
        { label: 'FICHIER PDF', value: 'pdf' },
        { label: 'FICHIER VIDEO', value: 'doc' },
        { label: 'FICHIER IMAGE', value: 'docx' }
      ]);
      const auteur = ref();
      
      // Stepper functionality
      const currentStep = ref(1);
      const isSubmitting = ref(false);
      
      // File upload functionality
      const selectedFile = ref<File | null>(null);
      const dragOver = ref(false);
      const uploadProgress = ref(0);
      const imagePreviewUrl = ref<string | null>(null);
      const videoPreviewUrl = ref<string | null>(null);
      
      // Form data tracking
      const formData = reactive({
        titre: '',
        sousTitre: '',
        version: '',
        langue: 0,
        description: '',
        anneePublication: '',
        categorie: 0,
        secteur:0,
        maisonEdition: 0,
        nomFichier: '',
        auteur: '',
        typeFichier: '',
        reference: '',
        direction: 0,
        service: null as number | null, 
        genre: [] as number[],
        tag: [] as number[],
        estTelechargeable: false,
        estPublique: false,

      });

      

      // Computed properties
      const canProceedToNextStep = computed(() => {
        switch (currentStep.value) {
          case 1:
            return formData.titre && formData.anneePublication;
          case 2:
            return formData.categorie && formData.maisonEdition && formData.secteur;
          case 3:
            return selectedFile.value !== null;
          default:
            return true;
        }
      });
      const formValues = ref({
        direction: null,
        service: null
      });
            // Stepper methods
      const nextStep = async () => {
        if (currentStep.value < 4) {
          let canProceed = false;
          
          // Validation avec VeeValidate puisque tous les champs restent dans le DOM
          if (documentForm.value) {
            const validationResult = await documentForm.value.validate();
            console.log('Résultat de validation:', validationResult);
            
            // Validation spécifique selon l'étape
            switch (currentStep.value) {
              case 1: {
                // Vérifier les champs obligatoires du step 1
                const step1Valid = 
                formData.reference &&
                formData.titre && 
                formData.anneePublication && 
                formData.titre.trim() !== '' && 
                formData.anneePublication.toString().trim() !== '';
                
                if (step1Valid) {
                  canProceed = true;
                } else {
                  error('Veuillez remplir tous les champs obligatoires de l\'étape 1');
                }
                break;
              }
                
              case 2: {
                // Vérifier les champs obligatoires du step 2
                const step2Valid = formData.categorie && 
                                  formData.maisonEdition && 
                                  formData.langue  &&
                                  formData.secteur;
                
                if (step2Valid) {
                  canProceed = true;
                } else {
                  error('Veuillez remplir tous les champs obligatoires de l\'étape 2');
                }
                break;
              }
                
              case 3: {
                
                // Vérifier spécifiquement la validation du champ nomFichier
                const fieldError = validationResult.errors.nomFichier;
                console.log('Erreur champ nomFichier:', fieldError);
                
                // Conditions de validation
                const hasFile = selectedFile.value !== null;
                const hasFileName = formData.nomFichier !== '' && formData.nomFichier !== undefined && formData.nomFichier !== null;
                const noFieldError = !fieldError;
                
                // Le step 3 est valide si nous avons un fichier ET pas d'erreur de validation
                const step3Valid = hasFile && hasFileName && noFieldError;
                
                if (step3Valid) {
                  canProceed = true;
                  console.log('✅ Step 3 validation RÉUSSIE');
                } else {
                  // Message d'erreur spécifique selon le problème
                  if (!hasFile) {
                    error('Veuillez sélectionner un fichier');
                  } else if (!hasFileName) {
                    error('Nom de fichier manquant');
                  } else if (!noFieldError) {
                    error('Fichier invalide: ' + fieldError);
                  }
                }
                break;
              }
                
              default:
                canProceed = true;
            }
          } else {
            // Fallback si le formulaire n'est pas disponible
            canProceed = !!canProceedToNextStep.value;
          }
          
          if (canProceed) {
            currentStep.value++;
            console.log(`Passage à l'étape ${currentStep.value}`);
          }
        }
      };

      const previousStep = () => {
        if (currentStep.value > 1) {
          currentStep.value--;
        }
      };

      
      const handleFileDrop = (event: DragEvent) => {
        dragOver.value = false;
        const files = event.dataTransfer?.files;
        if (files && files.length > 0) {
          handleFileSelection(files[0]);
        }
      };

      const handleFileSelect = (event: Event) => {
        const target = event.target as HTMLInputElement;
        const files = target.files;
        if (files && files.length > 0) {
          handleFileSelection(files[0]);
        }
      };

      const handleFileSelection = (file: File) => {
        
        const maxSize = 10 * 1024 * 1024;
        if (file.size > maxSize) {
          error('Le fichier est trop volumineux. Taille maximum: 10MB');
          return;
        }

        // Validate file type
        const allowedTypes = [
          'application/pdf',
          'application/msword',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          'application/vnd.openxmlformats-officedocument.presentationml.presentation',
          'text/plain',
          'image/jpeg',
          'image/jpg',
          'image/png',
          'image/gif',
          'image/webp',
          'image/bmp',
          'video/mp4',
          'video/quicktime',
          'video/x-msvideo',
          'video/x-matroska',
          'video/webm',
          'video/x-flv',
          'video/x-ms-wmv'
        ];
        
        if (!allowedTypes.includes(file.type)) {
          error(`Type de fichier non supporté: ${file.type}. Formats acceptés: PDF, DOC, DOCX, TXT, JPG, PNG, GIF, WEBP, MP4, MOV, AVI, MKV, WEBM`);
          return;
        }

        // Mettre à jour le fichier sélectionné ET formData immédiatement
        selectedFile.value = file;
        formData.nomFichier = file.name;
        
        // Générer un aperçu pour les images
        if (isImageFile(file)) {
          const reader = new FileReader();
          reader.onload = (e) => {
            imagePreviewUrl.value = e.target?.result as string;
          };
          reader.readAsDataURL(file);
          videoPreviewUrl.value = null;
        } 
        // Générer un aperçu pour les vidéos
        else if (isVideoFile(file)) {
          const reader = new FileReader();
          reader.onload = (e) => {
            videoPreviewUrl.value = e.target?.result as string;
          };
          reader.readAsDataURL(file);
          imagePreviewUrl.value = null;
        } 
        else {
          imagePreviewUrl.value = null;
          videoPreviewUrl.value = null;
        }
        
        // Synchronisation avec VeeValidate
        if (documentForm.value) {
          // Utiliser setFieldValue ET setValues pour forcer la synchronisation
          documentForm.value.setFieldValue('nomFichier', file.name);
          documentForm.value.setFieldTouched('nomFichier', true);
          
          // Alternative: mettre à jour avec setValues
          // const currentValues = documentForm.value.values;
          // documentForm.value.setValues({
          //   ...currentValues,
          //   nomFichier: file.name
          // });
          
          console.log('Valeurs du formulaire après setValues:', documentForm.value.values);
          
          // Forcer la validation immédiatement
          setTimeout(async () => {
            if (documentForm.value) {
              const fieldValidation = await documentForm.value.validateField('nomFichier');
              // Vérifier l'état global
              const globalValidation = await documentForm.value.validate();
            }
          }, 200); // Délai un peu plus long pour s'assurer de la synchronisation
        }

        simulateUpload();
      };

      const removeFile = () => {
        selectedFile.value = null;
        uploadProgress.value = 0;
        imagePreviewUrl.value = null;
        videoPreviewUrl.value = null;
        
        // Réinitialiser formData.nomFichier
        formData.nomFichier = '';
        
        // Réinitialiser VeeValidate
        if (documentForm.value) {
          documentForm.value.setFieldValue('nomFichier', '');
          documentForm.value.setFieldTouched('nomFichier', false);
        }
        
        console.log('Fichier supprimé');
      };

      const simulateUpload = () => {
        uploadProgress.value = 0;
        const interval = setInterval(() => {
          uploadProgress.value += 10;
          if (uploadProgress.value >= 100) {
            clearInterval(interval);
          }
        }, 200);
      };

      const formatFileSize = (bytes: number): string => {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
      };

      // Vérifier si le fichier est une image
      const isImageFile = (file: File): boolean => {
        return file.type.startsWith('image/');
      };

      // Vérifier si le fichier est une vidéo
      const isVideoFile = (file: File): boolean => {
        return file.type.startsWith('video/');
      };

      // Helper methods for labels
      const getCategoryLabel = (value: string | any) => {
        if (!categorieOptions.value || !Array.isArray(categorieOptions.value)) return value?.label || value;
        const category = categorieOptions.value.find((cat: any) => cat.value === value?.value || cat.value === value);
        return category ? category : (value?.label || value);
      };

      const getSecteurLabel = (value: string | any) => {
        if (!secteurOptions.value || !Array.isArray(secteurOptions.value)) return value?.label || value;
        const secteurr = secteurOptions.value.find((sect: any) => sect.value === value?.value || sect.value === value);
        return secteurr ? secteurr : (value?.label || value);
      };

      const getMaisonEditionLabel = (value: string | any) => {
        if (!maisonEditionOptions.value || !Array.isArray(maisonEditionOptions.value)) return value?.label || value;
        const maison = maisonEditionOptions.value.find((m: any) => m.value === value?.value || m.value === value);
        return maison ? maison.label : (value?.label || value);
      };

      const getLangueLabel = (value: string | any) => {
        if (!langueOptions.value || !Array.isArray(langueOptions.value)) return value?.label || value;
        const langue = langueOptions.value.find((l: any) => l.value === value?.value || l.value === value);
        return langue ? langue : (value?.label || value);
      };

      // Update form data method
      const updateFormData = (values: any) => {
        Object.assign(formData, values);
      };

      // Individual field update methods
      // const updateTextField = (event: Event | any, field: string) => {
      //   const target = event.target as HTMLInputElement;
      //   if(event && event.target){
      //     formData[field] = target.value ;
      //   }else{
      //     formData[field] = event;
      //   }

      //   console.log("formaData", documentForm.value);
        
      // };

      // Méthode pour mettre à jour les données du formulaire
      const updateFormField = (field: string, value: any) => {
       
        formData[field] = value;
        console.log(`Field ${field} updated:`, value);
        console.log('Current ok formData:', documentForm.value);
      };


      // File input reference
      const fileInput = ref<HTMLInputElement | null>(null);

    // Données auteurs récupérées du modal
    const handleClose = (values) => {
      auteur.value = values;
      auteurOptions.value.push({
            value: 0,
            label: values.nom,
          });
          auteurSelected.value = 0;
      console.log("Modal fermé avec les valeurs:", values);
    };

    // watch(defaultEstTelechargeable, (newVal) => {
    //   defaultEstTelechargeable.value = !defaultEstTelechargeable.value;
    // });

    // watch(defaultEstPublique, (newVal) => {
    //   defaultEstPublique.value = !defaultEstPublique.value;
    // });

      // Soumission du formulaire


    const addDocument = async (values: any, {resetForm}: any) => {
        isSubmitting.value = true;
        // console.log("Données du formulaire VeeValidate:", values);
        // console.log("formData reactive:", formData);
        // console.log("selectedFile:", selectedFile.value);

        try {
          // Créer FormData pour l'upload du fichier
          const formDataToSend = new FormData();
          
          // Ajouter les champs du formulaire
          formDataToSend.append('reference', values.reference || formData.reference || '');
          formDataToSend.append('titre', values.titre || formData.titre || '');
          formDataToSend.append('sousTitre', values.sousTitre || formData.sousTitre || '');
          formDataToSend.append('version', values.version || formData.version || '');
          formDataToSend.append('description', values.description || formData.description || '');
          formDataToSend.append('anneePublication', (values.anneePublication || formData.anneePublication || '').toString());
          formDataToSend.append("estTelechargeable",String(values.estTelechargeable));
          formDataToSend.append("estPublique",String(values.estPublique));


          // formDataToSend.append('auteur', values.auteur ? formData.auteur : auteur.value );
          // console.log("auteur sélectionné:", values.auteur, formData.auteur, auteur.value);


          // Déterminer quelle valeur sera utilisée
          const auteurToSend = values.auteur ? formData.auteur : auteur.value;

          if (typeof auteurToSend === 'object' && auteurToSend !== null) {
            formDataToSend.append('auteur', JSON.stringify(auteurToSend));
          } else {
            formDataToSend.append('auteur', auteurToSend);
          }

          const langue = values.langue?.value || formData.langue || values.langue;
          const categorie = values.categorie?.value || formData.categorie || values.categorie;
          const secteur = values.secteur?.value || formData.secteur || values.secteur;
          const maisonEdition = values.maisonEdition?.value || formData.maisonEdition || values.maisonEdition;
          const typeFichier = values.typeFichier?.value || formData.typeFichier || values.typeFichier;
          const service = values.service?.value || formData.service || values.service;
          const genre = values.genre?.value || formData.genre || '';
          
          formDataToSend.append('langue', langue.toString());
          formDataToSend.append('categorie', categorie.toString());
           formDataToSend.append('secteur', secteur.toString());
          formDataToSend.append('maisonEdition', maisonEdition.toString());
          formDataToSend.append('typeFichier', typeFichier.toString());
          formDataToSend.append('service', service.toString());
          formDataToSend.append('genre', genre);

          // Ajouter le fichier si il existe
          if (selectedFile.value) {
            formDataToSend.append('nomFichier', selectedFile.value, selectedFile.value.name);
          }

          // console.log("FormData to send:");
          // formDataToSend.forEach((value, key) => {
          //   if(typeof value === 'object') {
          //     console.log(key + ': ', value.name, value.size, value.type);
          //   } else {
          //     console.log(key + ': ' + value);
          //   }
          // });
            
          const response = await axios.post('/documents', formDataToSend, { 
            headers: { 
              'Content-Type': 'multipart/form-data',
              'Accept': '*/*' 
            } 
          });


          if(response.data.code == 201) { 
            success(response.data.message);
            resetForm();
            // Réinitialiser aussi les états locaux
            selectedFile.value = null;
            formData.nomFichier = '';
            uploadProgress.value = 0;
            router.push({ name: "ListeDocumentPage" });
          }

        } catch (err: any) {
          console.error('Erreur lors de l\'envoi:', err);
          error(err.response?.data?.message || 'Une erreur est survenue');
        } finally {
          isSubmitting.value = false;
        }
      };

      // const fetchSepcificEntity = async (optionName: any, url: string, param: Array<string>) => {
      //   try{
      //     console.log("parametre", param[0]);
      //     const response = await ApiService.get(url);
      //     const data = response.data.data.data;
      //     optionName.value = data.map((item: any) => ({
      //       value: param[0] ? item[param[0]] : item.id,
      //       label: param[1] ? item[param[1]] : item.nom,
      //     }));
      //   }
      //   catch(error){
      //     console.log("Nous avons une exception", error);
      //   }
      // };

      const fetchSepcificEntity = async (optionName: any, url: string, param: string[]) => {
    try {
      const response = await ApiService.get(url);
      const data = response.data.data.data;
      optionName.value = data.map((item: any) => ({
        value: param[0] ? item[param[0]] : item.id,
        label: param[1] ? item[param[1]] : item.nom,
        ...(item.direction ? { directionId: item.direction.id } : {}), // <- pour services
      }));
    } catch (error) {
      console.error("Erreur récupération données:", error);
    }
  };
  

      onMounted( async () => {
        await fetchSepcificEntity(categorieOptions, '/all/categories', ['id', 'nom']);
        await fetchSepcificEntity(secteurOptions, '/all/secteurs', ['id', 'nom']);
        await fetchSepcificEntity(maisonEditionOptions, 'all/maisonEditions', ['id', 'nom']);
        await fetchSepcificEntity(langueOptions, '/all/langues', ['id', 'nom']);
        await fetchSepcificEntity(auteurOptions, '/all/auteurs', ['id', 'nom']);
        await fetchSepcificEntity(directionOptions, '/all/directions', ['id', 'libelle']);
        await fetchSepcificEntity(serviceOptions, '/all/services', ['id', 'libelle']);
        await fetchSepcificEntity(tagOptions, '/all/tags?limit', ['id', 'nom']);
        await fetchSepcificEntity(genreOptions, '/all/genres', ['id', 'nom']);
        filteredServiceOptions.value = [...serviceOptions.value];

        console.log("DATADATA", auteurOptions.value);
        // console.log("maisonEditionOptions", maisonEditionOptions.value);

      });
       watch(() => formData.direction, (newDirection) => {
    if (newDirection && newDirection !== 0) {
      filteredServiceOptions.value = serviceOptions.value.filter(
        (s: any) => s.directionId === newDirection
      );
    } else {
      filteredServiceOptions.value = [...serviceOptions.value];
    }

    // Réinitialiser le service sélectionné si la direction change
    formData.service = 0;
  }, { immediate: true });

  
      return { 
        genreOptions,
        handleClose,
        documentSchema, 
        addDocument, 
        documentForm,
        categorieOptions,
        typeFichierOptions,
        langueOptions,
        directionOptions,
        serviceOptions,
        auteurOptions,
        tagOptions,
        showMErr,
        categories,
        secteurs,
        maisonEditionOptions,
        // Stepper
        currentStep,
        nextStep,
        previousStep,
        canProceedToNextStep,
        isSubmitting,
        // File upload
        selectedFile,
        selectedFileName,
        dragOver,
        uploadProgress,
        imagePreviewUrl,
        videoPreviewUrl,
        handleFileDrop,
        handleFileSelect,
        removeFile,
        formatFileSize,
        isImageFile,
        isVideoFile,
        formData,
        getCategoryLabel,
        getMaisonEditionLabel,
        updateFormData,
        fileInput,
        updateFormField,
        getLangueLabel,
        secteurOptions,
        filteredServiceOptions

      };
    },
  });
  </script>

 <style scoped>


      /* Modern Form Container */
      .modern-form-container {
        /* max-width: 1000px; */
        width: 100%;
        margin: 0 auto;
        padding: 0;
      }

      .modern-card {
        border: none;
        border-radius: 16px;
        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
        background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
      }

      /* Progress Steps */
      .form-progress {
        margin-bottom: 2rem;
      }

      .step-container {
        display: flex;
        width: 100%;
        position: relative;
        padding: 0 1rem;
        margin: 0;
        gap: 1rem; /* Espace entre les steps */
      }

      .step-container::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 15%; /* Commence au centre de la première colonne */
        right: 15%; /* Se termine au centre de la dernière colonne */
        height: 3px;
        background: linear-gradient(90deg, #e9ecef 0%, #e9ecef 100%);
        border-radius: 2px;
        z-index: 1;
      }

      .step-container::after {
        content: '';
        position: absolute;
        top: 50%;
        left: 15%;
        height: 3px;
        background: linear-gradient(90deg, #007bff, #28a745);
        border-radius: 2px;
        z-index: 2;
        transition: width 0.6s ease;
        width: 0%;
      }

      /* Animation de progression */
      .step-container.step-1::after { width: 0%; }
      .step-container.step-2::after { width: 30%; }
      .step-container.step-3::after { width: 60%; }
      .step-container.step-4::after { width: 80%; }

      .step {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        z-index: 3;
        background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
        /* padding: 1.5rem 1rem; */
        padding: 0; 
        flex: 1;
        max-width: calc(25% - 0.75rem); /* 25% moins l'espace pour les gaps */
        text-align: center;
        border-radius: 16px;
        border: 2px solid #e9ecef;
        transition: all 0.4s ease;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        margin: 0.5rem 0;
      }

      .step:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
      }

      .step-number {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        font-size: 16px;
        margin-bottom: 12px;
        transition: all 0.4s ease;
        background: linear-gradient(135deg, #e9ecef, #dee2e6);
        color: #6c757d;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        border: 2px solid #ffffff;
      }

      .step.active {
        background: linear-gradient(135deg, #e3f2fd 0%, #ffffff 100%);
        border-color: #007bff;
        transform: translateY(-4px);
        box-shadow: 0 12px 25px rgba(0, 123, 255, 0.15);
      }

      .step.active .step-number {
        background: linear-gradient(135deg, #007bff, #0056b3);
        color: white;
        transform: scale(1.1);
        box-shadow: 0 6px 20px rgba(0, 123, 255, 0.4);
        border-color: #ffffff;
      }

      .step.completed {
        background: linear-gradient(135deg, #e8f5e8 0%, #ffffff 100%);
        border-color: #28a745;
        box-shadow: 0 8px 20px rgba(40, 167, 69, 0.15);
      }

      .step.completed .step-number {
        background: linear-gradient(135deg, #28a745, #20c997);
        color: white;
        box-shadow: 0 6px 20px rgba(40, 167, 69, 0.4);
        position: relative;
        border-color: #ffffff;
      }

      .step.completed .step-number::before {
        content: '✓';
        position: absolute;
        font-size: 20px;
        font-weight: bold;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }

      .step.completed .step-number::after {
        display: none;
      }

      .step span {
        font-size: 14px;
        font-weight: 600;
        color: #6c757d;
        text-align: center;
        line-height: 1.3;
        word-wrap: break-word;
        max-width: 100%;
        transition: all 0.3s ease;
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }

      .step.active span {
        color: #007bff;
        font-weight: 700;
        transform: scale(1.05);
      }

      .step.completed span {
        color: #28a745;
        font-weight: 700;
      }

      /* Effet de pulsation pour l'étape active */
      .step.active .step-number {
        animation: pulse 2s infinite;
      }

      @keyframes pulse {
        0% {
          box-shadow: 0 6px 20px rgba(0, 123, 255, 0.4);
        }
        50% {
          box-shadow: 0 6px 20px rgba(0, 123, 255, 0.2);
        }
        100% {
          box-shadow: 0 6px 20px rgba(0, 123, 255, 0.4);
        }
      }

      /* Step Content */
      .step-content {
        min-height: 300px;
        padding: 1rem;
        transition: all 0.4s ease;
        opacity: 1;
        transform: translateX(0);
      }

      /* Animation pour les steps cachés */
      .step-content.d-none {
        display: none !important;
      }

      /* Animation d'entrée pour les steps visibles */
      .step-content:not(.d-none) {
        animation: fadeInSlide 0.5s ease forwards;
      }

      @keyframes fadeInSlide {
        0% {
          opacity: 0;
          transform: translateX(20px);
        }
        100% {
          opacity: 1;
          transform: translateX(0);
        }
      }

      .step-title {
        color: #2c3e50;
        font-weight: 600;
        border-bottom: 2px solid #e9ecef;
        padding-bottom: 1rem;
        margin-bottom: 2rem;
      }

      /* Modern Inputs */
      .modern-input-group,
      .modern-select-group {
        position: relative;
        margin-bottom: 1.5rem;
      }

      .modern-label {
        display: block;
        font-weight: 600;
        color: #2c3e50;
        margin-bottom: 0.5rem;
        font-size: 14px;
      }

      .modern-input {
        width: 100%;
        padding: 12px 16px;
        border: 2px solid #e9ecef;
        border-radius: 8px;
        font-size: 14px;
        transition: all 0.3s ease;
        background: white;
      }

      .modern-input:focus {
        outline: none;
        border-color: #FFBE00;
        /* box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25); */
        box-shadow: 0 0 0 0.2rem rgba(255, 190, 0, 0.25);
        transform: translateY(-1px);
      }

      /* Conteneur principal du select */
      :deep(.multiselect) {
        position: relative;
        z-index: 1; /* z-index bas quand fermé */
      }

      /* Quand le select est ouvert/actif */
      :deep(.multiselect--active) {
        z-index: 9999 !important; /* z-index très élevé quand ouvert */
      }

      /* Container du menu déroulant */
      :deep(.multiselect__content-wrapper) {
        z-index: 9999 !important;
        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2) !important;
        border-radius: 8px !important;
        border: 1px solid #ddd !important;
        background: white !important;
        max-height: 300px !important;
      }

      /* Options dans le menu */
      :deep(.multiselect__option) {
        padding: 12px 15px !important;
      }

      /* Option sélectionnée */
      :deep(.multiselect__option--selected) {
        background: #007bff !important;
        color: white !important;
      }

      /* Option au survol */
      :deep(.multiselect__option--highlight) {
        background: #f0f0f0 !important;
        color: #333 !important;
      }

      .modern-multiselect {
        border-radius: 8px !important;
        border: 2px solid #e9ecef !important;
        transition: all 0.3s ease !important;
        /* border: 3px solid red !important; */
      }

      .modern-multiselect:focus-within {
        border-color: #007bff !important;
        box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25) !important;
        transform: translateY(-1px);
      }

      /* Style global pour les dropdowns Multiselect */
      .modern-select-group {
        position: relative;
        z-index: 50;
      }

      /* Quand le multiselect est ouvert */
      .modern-select-group:has(.multiselect--open) {
        z-index: 1000;
      }

      /* Alternative pour les navigateurs qui ne supportent pas :has() */
      .modern-select-group .multiselect--open {
        z-index: 1000;
        position: relative;
      }

      /* Styles pour le dropdown ouvert */
      .modern-multiselect :deep(.multiselect__content-wrapper) {
        z-index: 1001 !important;
        position: absolute !important;
        background: white !important;
        border: 1px solid #e9ecef !important;
        border-radius: 8px !important;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
        max-height: 200px !important;
        overflow-y: auto !important;
      }

      /* Styles pour les options */
      .modern-multiselect :deep(.multiselect__option) {
        padding: 8px 12px !important;
        border-bottom: 1px solid #f8f9fa !important;
      }

      .modern-multiselect :deep(.multiselect__option:hover) {
        background: #f8f9fa !important;
        color: #2c3e50 !important;
      }

      .modern-multiselect :deep(.multiselect__option--selected) {
        background: #007bff !important;
        color: white !important;
      }

      .error-message {
        color: #dc3545;
        font-size: 12px;
        margin-top: 0.25rem;
        display: block;
      }

      /* File Upload Zone */
      .file-upload-zone {
        border: 2px dashed #ced4da;
        border-radius: 12px;
        padding: 3rem 2rem;
        text-align: center;
        transition: all 0.3s ease;
        background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
        position: relative;
        overflow: hidden;
      }

      .file-upload-zone:hover,
      .file-upload-zone.drag-over {
        border-color: #007bff;
        background: linear-gradient(135deg, #e3f2fd 0%, #ffffff 100%);
        transform: translateY(-2px);
        box-shadow: 0 8px 25px rgba(0, 123, 255, 0.15);
      }

      .upload-icon {
        font-size: 3rem;
        color: #6c757d;
        margin-bottom: 1rem;
        transition: all 0.3s ease;
      }

      .file-upload-zone:hover .upload-icon,
      .file-upload-zone.drag-over .upload-icon {
        color: #007bff;
        transform: scale(1.1);
      }

      .upload-content h5 {
        color: #2c3e50;
        font-weight: 600;
        margin-bottom: 0.5rem;
      }

      /* File Preview */
      .file-preview {
        background: white;
        border-radius: 8px;
        padding: 1.5rem;
        border: 1px solid #e9ecef;
        text-align: center !important;

        
      }

      .file-info {
        display: flex;
        align-items: center;
        gap: 1rem;
        margin-bottom: 1rem;

        display: flex;
        min-width: 600px;
        flex-direction: column;
        align-items: center;
      }

      .file-icon {
        font-size: 2rem;
        color: #007bff;
      }

      .file-details h6 {
        margin: 0;
        color: #2c3e50;
        font-weight: 600;
      }

      .file-details small {
        color: #6c757d;
      }

      /* Image Preview */
      .image-preview {
        text-align: center;
        padding: 1rem;
        background: #f8f9fa;
        border-radius: 8px;
        border: 1px solid #e9ecef;
      }

      .preview-image {
        max-width: 100%;
        max-height: 200px;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        object-fit: cover;
      }

      /* Video Preview */
      .video-preview {
        text-align: center;
        padding: 1rem;
        background: #f8f9fa;
        border-radius: 8px;
        border: 1px solid #e9ecef;
      }

      .preview-video {
        max-width: 100%;
        max-height: 200px;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        object-fit: cover;
      }

      /* Upload Progress */
      .upload-progress {
        margin-top: 1rem;
      }

      .progress {
        height: 8px;
        border-radius: 4px;
        background: #e9ecef;
        overflow: hidden;
      }

      .progress-bar {
        height: 100%;
        background: linear-gradient(90deg, #007bff, #28a745);
        border-radius: 4px;
        transition: width 0.3s ease;
      }

      /* Confirmation Card */
      .confirmation-card {
        background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
        border-radius: 12px;
        padding: 2rem;
        border: 1px solid #dee2e6;
      }

      .summary-section h6 {
        color: #2c3e50;
        font-weight: 600;
        margin-bottom: 1rem;
        padding-bottom: 0.5rem;
        border-bottom: 1px solid #dee2e6;
      }

      .summary-section p {
        margin-bottom: 0.5rem;
        color: #495057;
      }

      /* Form Navigation */
      .form-navigation {
        display: flex;
        justify-content: start;
        margin-left: 15px;
        align-items: center;
        gap: 1rem;
        padding-top: 2rem;
        border-top: 2px solid #e9ecef;
      }

      /* Button Styles */
      .btn {
        padding: 12px 24px;
        border-radius: 8px;
        font-weight: 600;
        transition: all 0.3s ease;
        border: none;
        position: relative;
        overflow: hidden;
      }

      .btn:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      }

      .btn-primary {
        /* background: linear-gradient(135deg, #007bff, #0056b3); */
        background: linear-gradient(135deg, #57da75, #039a38);
        /* border: 2px solid #28a745;
        color: white; */
      }

      .btn-success {
        background: linear-gradient(135deg, #34cc57, #05855f);
        border: 2px solid #28a745;
        color: white;
      }

      .btn-success:hover {
        background: linear-gradient(135deg, #218838, #1ea085);
        border-color: #1e7e34;
      }

      .btn-outline-secondary {
        border: 2px solid #6c757d;
        color: #6c757d;
        background: transparent;
      }

      .btn-outline-danger {
        border: 2px solid #dc3545;
        color: #dc3545;
        background: transparent;
      }

      .btn:disabled {
        opacity: 0.6 !important;
        transform: none !important;
        cursor: not-allowed !important;
      }

      /* Responsive Design */
      @media (max-width: 768px) {
        .modern-form-container {
          padding: 1rem 0.5rem;
        }

        .step-container {
          flex-direction: column;
          gap: 1rem;
          padding: 0 0.5rem;
        }

        .step-container::before,
        .step-container::after {
          display: none; /* Masquer les lignes de connexion sur mobile */
        }

        .step {
          flex-direction: row;
          max-width: 100%;
          padding: 1rem 1.5rem;
          background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
          border-radius: 12px;
          margin-bottom: 0;
          border: 2px solid #e9ecef;
          justify-content: flex-start;
          text-align: left;
        }

        .step.active {
          background: linear-gradient(135deg, #e3f2fd 0%, #ffffff 100%);
          border-color: #007bff;
          transform: translateY(-2px);
        }

        .step.completed {
          background: linear-gradient(135deg, #e8f5e8 0%, #ffffff 100%);
          border-color: #28a745;
        }

        .step-number {
          margin-bottom: 0;
          margin-right: 1rem;
          width: 40px;
          height: 40px;
          font-size: 14px;
          flex-shrink: 0;
        }

        .step span {
          font-size: 15px;
          text-align: left;
          flex: 1;
          text-transform: none;
          letter-spacing: normal;
        }

        .step-content {
          min-height: 300px;
          padding: 0.5rem;
        }

        .file-upload-zone {
          padding: 2rem 1rem;
        }

        .form-navigation {
          flex-direction: column;
          gap: 0.5rem;
        }

        .form-navigation .btn {
          width: 100%;
          max-width: 200px;
        }
      }

      /* Tablettes */
      @media (min-width: 769px) and (max-width: 1024px) {
        .step-container {
          gap: 0.75rem;
          padding: 0 0.5rem;
        }

        .step {
          padding: 1.25rem 0.75rem;
          border-radius: 14px;
          max-width: calc(25% - 0.56rem);
        }

        .step span {
          font-size: 13px;
        }

        .step-number {
          width: 45px;
          height: 45px;
          font-size: 15px;
        }
      }

      /* Grands écrans */
      @media (min-width: 1200px) {
        .modern-form-container {
          /* max-width: 1200px; */
          width: 100%;
          margin: 0 auto;
        }

        .step-container {
          gap: 1.5rem;
          padding: 0 1.5rem;
        }

        .step {
          padding: 1rem 1.25rem;
          border-radius: 15px;
          max-width: calc(25% - 1.125rem);
          box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
        }

        .step:hover {
          transform: translateY(-4px);
          box-shadow: 0 12px 30px rgba(0, 0, 0, 0.15);
        }

        .step span {
          font-size: 15px;
        }

        .step-number {
          width: 55px;
          height: 55px;
          font-size: 18px;
        }

        .step.active .step-number {
          transform: scale(1.15);
        }
      }

      /* Loading Animation */
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }

      .fa-spin {
        animation: spin 1s linear infinite;
      }

      /* Hover Effects */
      .modern-input-group:hover .modern-input,
      .modern-select-group:hover .modern-multiselect {
        border-color: #FFBE00;;
        transform: translateY(-1px);
      }
  <style scoped>


      /* Modern Form Container */
      .modern-form-container {
        /* max-width: 1000px; */
        width: 100%;
        margin: 0 auto;
        padding: 0;
      }

      .modern-card {
        border: none;
        border-radius: 16px;
        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
        background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
      }

      /* Progress Steps */
      .form-progress {
        margin-bottom: 2rem;
      }

      .step-container {
        display: flex;
        width: 100%;
        position: relative;
        padding: 0 1rem;
        margin: 0;
        gap: 1rem; /* Espace entre les steps */
      }

      .step-container::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 15%; /* Commence au centre de la première colonne */
        right: 15%; /* Se termine au centre de la dernière colonne */
        height: 3px;
        background: linear-gradient(90deg, #e9ecef 0%, #e9ecef 100%);
        border-radius: 2px;
        z-index: 1;
      }

      .step-container::after {
        content: '';
        position: absolute;
        top: 50%;
        left: 15%;
        height: 3px;
        background: linear-gradient(90deg, #007bff, #28a745);
        border-radius: 2px;
        z-index: 2;
        transition: width 0.6s ease;
        width: 0%;
      }

      /* Animation de progression */
      .step-container.step-1::after { width: 0%; }
      .step-container.step-2::after { width: 30%; }
      .step-container.step-3::after { width: 60%; }
      .step-container.step-4::after { width: 80%; }

      .step {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        z-index: 3;
        background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
        /* padding: 1.5rem 1rem; */
        padding: 0; 
        flex: 1;
        max-width: calc(25% - 0.75rem); /* 25% moins l'espace pour les gaps */
        text-align: center;
        border-radius: 16px;
        border: 2px solid #e9ecef;
        transition: all 0.4s ease;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        margin: 0.5rem 0;
      }

      .step:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
      }

      .step-number {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        font-size: 16px;
        margin-bottom: 12px;
        transition: all 0.4s ease;
        background: linear-gradient(135deg, #e9ecef, #dee2e6);
        color: #6c757d;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        border: 2px solid #ffffff;
      }

      .step.active {
        background: linear-gradient(135deg, #e3f2fd 0%, #ffffff 100%);
        border-color: #007bff;
        transform: translateY(-4px);
        box-shadow: 0 12px 25px rgba(0, 123, 255, 0.15);
      }

      .step.active .step-number {
        background: linear-gradient(135deg, #007bff, #0056b3);
        color: white;
        transform: scale(1.1);
        box-shadow: 0 6px 20px rgba(0, 123, 255, 0.4);
        border-color: #ffffff;
      }

      .step.completed {
        background: linear-gradient(135deg, #e8f5e8 0%, #ffffff 100%);
        border-color: #28a745;
        box-shadow: 0 8px 20px rgba(40, 167, 69, 0.15);
      }

      .step.completed .step-number {
        background: linear-gradient(135deg, #28a745, #20c997);
        color: white;
        box-shadow: 0 6px 20px rgba(40, 167, 69, 0.4);
        position: relative;
        border-color: #ffffff;
      }

      .step.completed .step-number::before {
        content: '✓';
        position: absolute;
        font-size: 20px;
        font-weight: bold;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }

      .step.completed .step-number::after {
        display: none;
      }

      .step span {
        font-size: 14px;
        font-weight: 600;
        color: #6c757d;
        text-align: center;
        line-height: 1.3;
        word-wrap: break-word;
        max-width: 100%;
        transition: all 0.3s ease;
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }

      .step.active span {
        color: #007bff;
        font-weight: 700;
        transform: scale(1.05);
      }

      .step.completed span {
        color: #28a745;
        font-weight: 700;
      }

      /* Effet de pulsation pour l'étape active */
      .step.active .step-number {
        animation: pulse 2s infinite;
      }

      @keyframes pulse {
        0% {
          box-shadow: 0 6px 20px rgba(0, 123, 255, 0.4);
        }
        50% {
          box-shadow: 0 6px 20px rgba(0, 123, 255, 0.2);
        }
        100% {
          box-shadow: 0 6px 20px rgba(0, 123, 255, 0.4);
        }
      }

      /* Step Content */
      .step-content {
        min-height: 300px;
        padding: 1rem;
        transition: all 0.4s ease;
        opacity: 1;
        transform: translateX(0);
      }

      /* Animation pour les steps cachés */
      .step-content.d-none {
        display: none !important;
      }

      /* Animation d'entrée pour les steps visibles */
      .step-content:not(.d-none) {
        animation: fadeInSlide 0.5s ease forwards;
      }

      @keyframes fadeInSlide {
        0% {
          opacity: 0;
          transform: translateX(20px);
        }
        100% {
          opacity: 1;
          transform: translateX(0);
        }
      }

      .step-title {
        color: #2c3e50;
        font-weight: 600;
        border-bottom: 2px solid #e9ecef;
        padding-bottom: 1rem;
        margin-bottom: 2rem;
      }

      /* Modern Inputs */
      .modern-input-group,
      .modern-select-group {
        position: relative;
        margin-bottom: 1.5rem;
      }

      .modern-label {
        display: block;
        font-weight: 600;
        color: #2c3e50;
        margin-bottom: 0.5rem;
        font-size: 14px;
      }

      .modern-input {
        width: 100%;
        padding: 12px 16px;
        border: 2px solid #e9ecef;
        border-radius: 8px;
        font-size: 14px;
        transition: all 0.3s ease;
        background: white;
      }

      .modern-input:focus {
        outline: none;
        border-color: #FFBE00;
        /* box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25); */
        box-shadow: 0 0 0 0.2rem rgba(255, 190, 0, 0.25);
        transform: translateY(-1px);
      }

      /* Conteneur principal du select */
      :deep(.multiselect) {
        position: relative;
        z-index: 1; /* z-index bas quand fermé */
      }

      /* Quand le select est ouvert/actif */
      :deep(.multiselect--active) {
        z-index: 9999 !important; /* z-index très élevé quand ouvert */
      }

      /* Container du menu déroulant */
      :deep(.multiselect__content-wrapper) {
        z-index: 9999 !important;
        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2) !important;
        border-radius: 8px !important;
        border: 1px solid #ddd !important;
        background: white !important;
        max-height: 300px !important;
      }

      /* Options dans le menu */
      :deep(.multiselect__option) {
        padding: 12px 15px !important;
      }

      /* Option sélectionnée */
      :deep(.multiselect__option--selected) {
        background: #007bff !important;
        color: white !important;
      }

      /* Option au survol */
      :deep(.multiselect__option--highlight) {
        background: #f0f0f0 !important;
        color: #333 !important;
      }

      .modern-multiselect {
        border-radius: 8px !important;
        border: 2px solid #e9ecef !important;
        transition: all 0.3s ease !important;
        /* border: 3px solid red !important; */
      }

      .modern-multiselect:focus-within {
        border-color: #007bff !important;
        box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25) !important;
        transform: translateY(-1px);
      }

      /* Style global pour les dropdowns Multiselect */
      .modern-select-group {
        position: relative;
        z-index: 50;
      }

      /* Quand le multiselect est ouvert */
      .modern-select-group:has(.multiselect--open) {
        z-index: 1000;
      }

      /* Alternative pour les navigateurs qui ne supportent pas :has() */
      .modern-select-group .multiselect--open {
        z-index: 1000;
        position: relative;
      }

      /* Styles pour le dropdown ouvert */
      .modern-multiselect :deep(.multiselect__content-wrapper) {
        z-index: 1001 !important;
        position: absolute !important;
        background: white !important;
        border: 1px solid #e9ecef !important;
        border-radius: 8px !important;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
        max-height: 200px !important;
        overflow-y: auto !important;
      }

      /* Styles pour les options */
      .modern-multiselect :deep(.multiselect__option) {
        padding: 8px 12px !important;
        border-bottom: 1px solid #f8f9fa !important;
      }

      .modern-multiselect :deep(.multiselect__option:hover) {
        background: #f8f9fa !important;
        color: #2c3e50 !important;
      }

      .modern-multiselect :deep(.multiselect__option--selected) {
        background: #007bff !important;
        color: white !important;
      }

      .error-message {
        color: #dc3545;
        font-size: 12px;
        margin-top: 0.25rem;
        display: block;
      }

      /* File Upload Zone */
      .file-upload-zone {
        border: 2px dashed #ced4da;
        border-radius: 12px;
        padding: 3rem 2rem;
        text-align: center;
        transition: all 0.3s ease;
        background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
        position: relative;
        overflow: hidden;
      }

      .file-upload-zone:hover,
      .file-upload-zone.drag-over {
        border-color: #007bff;
        background: linear-gradient(135deg, #e3f2fd 0%, #ffffff 100%);
        transform: translateY(-2px);
        box-shadow: 0 8px 25px rgba(0, 123, 255, 0.15);
      }

      .upload-icon {
        font-size: 3rem;
        color: #6c757d;
        margin-bottom: 1rem;
        transition: all 0.3s ease;
      }

      .file-upload-zone:hover .upload-icon,
      .file-upload-zone.drag-over .upload-icon {
        color: #007bff;
        transform: scale(1.1);
      }

      .upload-content h5 {
        color: #2c3e50;
        font-weight: 600;
        margin-bottom: 0.5rem;
      }

      /* File Preview */
      .file-preview {
        background: white;
        border-radius: 8px;
        padding: 1.5rem;
        border: 1px solid #e9ecef;
        text-align: center !important;

        
      }

      .file-info {
        display: flex;
        align-items: center;
        gap: 1rem;
        margin-bottom: 1rem;

        display: flex;
        min-width: 600px;
        flex-direction: column;
        align-items: center;
      }

      .file-icon {
        font-size: 2rem;
        color: #007bff;
      }

      .file-details h6 {
        margin: 0;
        color: #2c3e50;
        font-weight: 600;
      }

      .file-details small {
        color: #6c757d;
      }

      /* Image Preview */
      .image-preview {
        text-align: center;
        padding: 1rem;
        background: #f8f9fa;
        border-radius: 8px;
        border: 1px solid #e9ecef;
      }

      .preview-image {
        max-width: 100%;
        max-height: 200px;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        object-fit: cover;
      }

      /* Video Preview */
      .video-preview {
        text-align: center;
        padding: 1rem;
        background: #f8f9fa;
        border-radius: 8px;
        border: 1px solid #e9ecef;
      }

      .preview-video {
        max-width: 100%;
        max-height: 200px;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        object-fit: cover;
      }

      /* Upload Progress */
      .upload-progress {
        margin-top: 1rem;
      }

      .progress {
        height: 8px;
        border-radius: 4px;
        background: #e9ecef;
        overflow: hidden;
      }

      .progress-bar {
        height: 100%;
        background: linear-gradient(90deg, #007bff, #28a745);
        border-radius: 4px;
        transition: width 0.3s ease;
      }

      /* Confirmation Card */
      .confirmation-card {
        background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
        border-radius: 12px;
        padding: 2rem;
        border: 1px solid #dee2e6;
      }

      .summary-section h6 {
        color: #2c3e50;
        font-weight: 600;
        margin-bottom: 1rem;
        padding-bottom: 0.5rem;
        border-bottom: 1px solid #dee2e6;
      }

      .summary-section p {
        margin-bottom: 0.5rem;
        color: #495057;
      }

      /* Form Navigation */
      .form-navigation {
        display: flex;
        justify-content: start;
        margin-left: 15px;
        align-items: center;
        gap: 1rem;
        padding-top: 2rem;
        border-top: 2px solid #e9ecef;
      }

      /* Button Styles */
      .btn {
        padding: 12px 24px;
        border-radius: 8px;
        font-weight: 600;
        transition: all 0.3s ease;
        border: none;
        position: relative;
        overflow: hidden;
      }

      .btn:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      }

      .btn-primary {
        /* background: linear-gradient(135deg, #007bff, #0056b3); */
        background: linear-gradient(135deg, #57da75, #039a38);
        /* border: 2px solid #28a745;
        color: white; */
      }

      .btn-success {
        background: linear-gradient(135deg, #34cc57, #05855f);
        border: 2px solid #28a745;
        color: white;
      }

      .btn-success:hover {
        background: linear-gradient(135deg, #218838, #1ea085);
        border-color: #1e7e34;
      }

      .btn-outline-secondary {
        border: 2px solid #6c757d;
        color: #6c757d;
        background: transparent;
      }

      .btn-outline-danger {
        border: 2px solid #dc3545;
        color: #dc3545;
        background: transparent;
      }

      .btn:disabled {
        opacity: 0.6 !important;
        transform: none !important;
        cursor: not-allowed !important;
      }

      /* Responsive Design */
      @media (max-width: 768px) {
        .modern-form-container {
          padding: 1rem 0.5rem;
        }

        .step-container {
          flex-direction: column;
          gap: 1rem;
          padding: 0 0.5rem;
        }

        .step-container::before,
        .step-container::after {
          display: none; /* Masquer les lignes de connexion sur mobile */
        }

        .step {
          flex-direction: row;
          max-width: 100%;
          padding: 1rem 1.5rem;
          background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
          border-radius: 12px;
          margin-bottom: 0;
          border: 2px solid #e9ecef;
          justify-content: flex-start;
          text-align: left;
        }

        .step.active {
          background: linear-gradient(135deg, #e3f2fd 0%, #ffffff 100%);
          border-color: #007bff;
          transform: translateY(-2px);
        }

        .step.completed {
          background: linear-gradient(135deg, #e8f5e8 0%, #ffffff 100%);
          border-color: #28a745;
        }

        .step-number {
          margin-bottom: 0;
          margin-right: 1rem;
          width: 40px;
          height: 40px;
          font-size: 14px;
          flex-shrink: 0;
        }

        .step span {
          font-size: 15px;
          text-align: left;
          flex: 1;
          text-transform: none;
          letter-spacing: normal;
        }

        .step-content {
          min-height: 300px;
          padding: 0.5rem;
        }

        .file-upload-zone {
          padding: 2rem 1rem;
        }

        .form-navigation {
          flex-direction: column;
          gap: 0.5rem;
        }

        .form-navigation .btn {
          width: 100%;
          max-width: 200px;
        }
      }

      /* Tablettes */
      @media (min-width: 769px) and (max-width: 1024px) {
        .step-container {
          gap: 0.75rem;
          padding: 0 0.5rem;
        }

        .step {
          padding: 1.25rem 0.75rem;
          border-radius: 14px;
          max-width: calc(25% - 0.56rem);
        }

        .step span {
          font-size: 13px;
        }

        .step-number {
          width: 45px;
          height: 45px;
          font-size: 15px;
        }
      }

      /* Grands écrans */
      @media (min-width: 1200px) {
        .modern-form-container {
          /* max-width: 1200px; */
          width: 100%;
          margin: 0 auto;
        }

        .step-container {
          gap: 1.5rem;
          padding: 0 1.5rem;
        }

        .step {
          padding: 1rem 1.25rem;
          border-radius: 15px;
          max-width: calc(25% - 1.125rem);
          box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
        }

        .step:hover {
          transform: translateY(-4px);
          box-shadow: 0 12px 30px rgba(0, 0, 0, 0.15);
        }

        .step span {
          font-size: 15px;
        }

        .step-number {
          width: 55px;
          height: 55px;
          font-size: 18px;
        }

        .step.active .step-number {
          transform: scale(1.15);
        }
      }

      /* Loading Animation */
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }

      .fa-spin {
        animation: spin 1s linear infinite;
      }

      /* Hover Effects */
      .modern-input-group:hover .modern-input,
      .modern-select-group:hover .modern-multiselect {
        border-color: #FFBE00;;
        transform: translateY(-1px);
      }
  </style>